import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import { textCodes, titleCodes, imageCodes } from '../../template_codes/29/about_page_codes';

export default function AboutPage() {
    return (
        <div>
            <h1 className="text-5xl text-center py-10">{titleCodes.aboutTitle.title}</h1>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8 pb-8 px-10'>
                <div>
                    <img src={imageCodes.aboutPhoto1.image} className="rounded-md"></img>
                </div>
                <div className='pb-10 text-justify text-sm'>
                    <p className="text-gray-500 leading-loose pb-4">{textCodes.about1.text}</p>
                    <p className="text-gray-500 leading-loose pb-4">{textCodes.about2.text}</p>
                    <p className="text-gray-500 leading-loose pb-4">{textCodes.about3.text}</p>
                </div>
                <div className='text-justify text-sm'>
                    <p className="text-gray-500 leading-loose pb-2">{textCodes.about4.text}</p>
                    <p className="text-gray-500 leading-loose pb-2">{textCodes.about5.text}</p>
                    <ul className='list-disc pl-4'>
                        <li><p className="text-gray-500 leading-loose pb-2">{textCodes.about6.text}</p></li>
                        <li><p className="text-gray-500 leading-loose pb-2">{textCodes.about7.text}</p></li>
                    </ul>
                    <p className="text-gray-500 leading-loose pb-2">{textCodes.about8.text}</p>
                </div>
                <div>
                    <img src={imageCodes.aboutPhoto2.image} className="rounded-md"></img>
                </div>
            </div>
        </div>
    );
}
